import { useLocation, Link } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 pt-16">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-300">
          <i className="ri-file-unknow-line text-3xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-900 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">抱歉，您访问的页面不存在或已被移除。</p>
        <Link
          to="/"
          className="mt-6 inline-block px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}